import React from "react";

// loader that reveals the logo from left to right and back
export default function Loader({ size = 150, logoSrc }) {
  const src =
    logoSrc || process.env.PUBLIC_URL + "/images/logo.gif"; // default animated gif

  return (
    <div className="loader-wrap">
      <img
        src={src}
        alt="loading"
        className="loader-img"
        style={{ width: `${size}px`, height: "auto" }}
      />
    </div>
  );
}
